import React, { Component } from "react";
import { db } from "../../firebase/index";
import Header from '../structure/Header/Header';
import BoothList from './BoothList';
import "./MainContainer.css";

let BOOTHLIST = [];

class MainContainer extends Component {
  state = {
    getDb: false,
    boothList: BOOTHLIST,
  }
  componentDidMount() {
    if (BOOTHLIST.length === 0){
      db.collection("Booth").get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const { host, name, url } = doc.data();
          BOOTHLIST.push({
            boothId: doc.id,
            host: host,
            name: name, 
            url: url
          });
        })
      }).then(() => {
        this.setState({
          getDb: true, 
          boothList: BOOTHLIST});
      });
    }
    else {
      this.setState({
        getDb: true
      });
    }

    // this._getBooths();
  }
  componentDidUpdate() {
  }
  _getBooths = async () => {
    const Booths = await this._callCollention();
    this.setState({
      getDb: true, 
      boothList: Booths});
  }
  
  _callCollention = () => {
    db.collection("Booth").get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        const { host, name, url } = doc.data();
        BOOTHLIST.push({
          boothId: doc.id,
          host: host,
          name: name, 
          url: url
        });
      })
    });
    return BOOTHLIST;
  }
  
  render(){
    const { getDb, boothList } = this.state;
    return(
      <div className="main">
        <Header page="main"/>
        <BoothList getDb={getDb} boothList={boothList}/>
        {/* { getDb ? (<BoothList getDb={getDb} boothList={boothList}/>) : 'Loading'} */}
      </div>
  );
}
};

export default MainContainer;